export interface MainCategory {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  cover: string;
}

export const mainCategories: MainCategory[] = [
  {
    slug: 'movie',
    name: '影视',
    desc: '电影、剧集与纪录片，覆盖科幻、悬疑、剧情等多元类型',
    icon: 'ri-film-line',
    cover: 'https://readdy.ai/api/search-image?query=cinema%20category%20illustration%20with%20a%20vintage%20film%20reel%20and%20clapperboard%2C%20warm%20peach%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20editorial%20design&width=400&height=300&seq=mvita-cat-movie&orientation=landscape',
  },
  {
    slug: 'short',
    name: '短视频',
    desc: '美食、运动、创意与纪录，几分钟看遍生活的有趣切面',
    icon: 'ri-video-line',
    cover: 'https://readdy.ai/api/search-image?query=short%20video%20category%20illustration%20with%20vertical%20video%20frames%20and%20a%20play%20button%2C%20bright%20peach%20gradient%2C%20clean%20geometric%20minimal%20design&width=400&height=300&seq=mvita-cat-short&orientation=landscape',
  },
  {
    slug: 'live',
    name: '直播专区',
    desc: '音乐、美食与陪伴型主播，实时互动不打烊',
    icon: 'ri-live-line',
    cover: 'https://readdy.ai/api/search-image?query=live%20streaming%20category%20illustration%20with%20a%20microphone%20and%20signal%20waves%2C%20warm%20amber%20spotlight%2C%20peach%20haze%2C%20clean%20minimal%20background&width=400&height=300&seq=mvita-cat-live&orientation=landscape',
  },
];

export interface FilterGroup {
  key: 'type' | 'region' | 'year';
  label: string;
  options: string[];
}

export const filterGroups: FilterGroup[] = [
  {
    key: 'type',
    label: '类型',
    options: ['全部', '科幻', '悬疑', '剧情', '纪录片', '美食', '运动', '音乐', '爱情', '科技', '创意', '纪录'],
  },
  {
    key: 'region',
    label: '地区',
    options: ['全部', '华语', '欧美', '日韩', '其他'],
  },
  {
    key: 'year',
    label: '年份',
    options: ['全部', '2024', '2023', '2022', '2021'],
  },
];

export const sortOptions = [
  { key: 'latest', label: '最新' },
  { key: 'hot', label: '热门' },
  { key: 'rating', label: '评分' },
];